import { SectionHeader } from 'components/ui'

export const DashboardHeader = () => <SectionHeader title="dashboard" showSearch={false} showIslandDropdown />
